module.exports = __webpack_public_path__ + "img/court_mobile.66a5f046.png";